// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Input Component
 */
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var connect = require('share/enhancers/Izenda.Connect');

  var EventsUtils = require('EventUtils');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = Validator()(require('share/components/controls/Izenda.Input'));

  var CustomInput = React.createClass({
    getDefaultProps: function() {
      return {
        className: 'form-control',
        type: 'text',
        value: ''
      };
    },

    getInitialState: function() {
      return {
        value: this.props.value,
        previousValue: this.props.value
      };
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        value: nextProps.value
      });
    },

    handleBlurInput: function() {
      var props = this.props;

      if (this.props.value === this.state.value) {
        return;
      }

      this.props.validation.validate().then(function(success) {
        if (success) {
          if (props.onValidate && props.onValidate(this.state.value)) {
            ReactDOM.findDOMNode(this.refs.input.refs.editor).focus();
            return;
          }
          props.beforeOnChange && props.beforeOnChange({value: this.state.value}, props.value);
          props.onChange && props.onChange({value: this.state.value});
        }
      }.bind(this));
    },

    handleChangeValue: function(value) {
      this.setState({value: value});
    },

    handleEnter: function(e) {
      if (e.key === 'Enter') {
        this.handleBlurInput();
      }
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;

      return (
        <Input
          ref='input'
          className={this.props.className}
          field={this.props.field}
          value={this.state.value}
          validations={this.props.validations}
          onChange={notifyChange(this.handleChangeValue, EventsUtils.INPUT)}
          onBlur={this.handleBlurInput}
          onKeyDown={this.handleEnter} />
      );
    }
  });

  module.exports = connect()(CustomInput);
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.CustomInput.jsx